import { ButtonInputWithPopover } from "@msys/ui";
import { OrganisationMembershipsFilters } from "../../../clients/graphqlTypes.js";
import { AutocompletePopperSlot } from "../../commons/AutocompletePopperSlot.js";
import { FilterProps } from "../../commons/filters/index.js";
import { FilterByOrganisationUsers } from "./FilterByOrganisationUsers.js";

export const FilterByOrganisationUsersButton = ({
  inputLabel,
  placeholder,
  ...props
}: FilterProps<string[]> & {
  inputLabel: string;
  placeholder: string;
  // Extra membership filters merged on top of the default status filter
  // (e.g. restrict the options to a known set of user ids).
  filters?: OrganisationMembershipsFilters;
}) => {
  return (
    <ButtonInputWithPopover
      label={inputLabel}
      counter={
        props.value && props.value.length > 0 ? props.value.length : undefined
      }
      content={
        <FilterByOrganisationUsers
          inputLabel={inputLabel}
          placeholder={placeholder}
          renderValue={() => null}
          open={true}
          slots={{ popper: AutocompletePopperSlot }}
          filterSelectedOptions={false}
          {...props}
        />
      }
      popoverWidth="xl"
    />
  );
};
